export default state => {
  const devices = state.devices.map(device => ({ ...device, connectionState: 'online' }))
  return { ...state, devices }
}
